import * as AccessCategory from "@/api/namespaces/organization/accessCategory";
import * as DatasetCategory from "@/api/namespaces/organization/datasetCategory";
import * as Project from "@/api/namespaces/organization/project";
import * as ProjectParticipation from "@/api/namespaces/organization/projectParticipation";
import * as Team from "@/api/namespaces/organization/team";
import * as User from "@/api/namespaces/organization/user";
import * as ProjectAccessRequest from "@/api/namespaces/organization/projectAccessRequest";

export {
  AccessCategory,
  DatasetCategory,
  Project,
  ProjectParticipation,
  Team,
  User,
  ProjectAccessRequest,
};
